<template>
  <div v-if="autocomplete">
    <v-autocomplete
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :value="fieldValue"
      :items="items"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
    >
    </v-autocomplete>
  </div>
  <div v-else>
    <v-select
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :value="fieldValue"
      :items="items"
      :success-messages="successes"
      :error-messages="errors"
      @change="value => (fieldValue = value)"
      :loading="loading"
    >
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    fieldName: String,
    object: Object,
    mask: String,
    fieldType: String,
    items: Array,
    itemText: String,
    itemValue: String,
    autocomplete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fieldValue: {
      get: function() {
        // Could not retrieve employee data from store state
        // return this.$store.state.employees.detailedEmployee[this.fieldName];

        //  Instead get data from object passed as prop
        return this.object[this.fieldName];
      },
      set: function(newValue) {
        this.loading = true;
        this.$store
          .dispatch("employees/update", {
            id: this.object.id || this.object.userId,
            [this.fieldName]: newValue
          })
          .then(res => {
            this.errors = [];
            this.successes.push("Saved!");
            this.successClear = setInterval(() => {
              this.wipeSuccesses();
            }, 1500);
          })
          .catch(res => {
            this.errors.push("Couldn't be saved");
            // reset the value?
          })
          .finally(res => {
            this.loading = false;
          });
      }
    }
  },

  methods: {
    updateField: function(newValue) {
      this.loading = true;

      this.$store.dispatch("employees/update", {
        id: this.object.id || this.object.userId,
        [this.fieldName]: newValue
      });
    },
    wipeSuccesses: function() {
      this.successes = [];
    }
  },

  data: function() {
    return {
      loading: false,
      fallback: "",
      errors: [],
      successes: []
    };
  }
};
</script>
